<template>
	<section class="create-profile-form grid-container">
		<form
			v-if="!showSuccess"
			id="CreateProfile_Form"
			name="CreateProfile_Form"
			@submit.prevent="createUser"
		>
			<div class="grid-x">
				<div class="cell small-12 medium-6 medium-offset-3">
					<h1 class="h2 create-profile-form__title">
						{{ $t('newaccount.titleText') }}
					</h1>
					<p class="create-profile-form__text">
						{{ $t('newaccount.descriptionText') }}
					</p>
				</div>

				<div
					class="cell small-12 medium-3 medium-offset-3 create-profile-form__margin"
				>
					<InputComponent
						:placeholderValue="$t('newaccount.firstNamePlaceholder') + '*'"
						v-model="name"
						:hasError="validation.name.error"
						:errorMessage="validation.name.message"
						:whiteErrorColor="true"
						:lightTheme="true"
						:autocomplete="'given-name'"
						@input-enter="retry()"
					></InputComponent>
				</div>
				<div class="cell small-12 medium-3">
					<InputComponent
						:placeholderValue="$t('newaccount.lastNamePlaceholder') + '*'"
						v-model="lastname"
						:hasError="validation.lastname.error"
						:errorMessage="validation.lastname.message"
						:whiteErrorColor="true"
						:lightTheme="true"
						:autocomplete="'family-name'"
						@input-enter="retry()"
					></InputComponent>
				</div>

				<div class="cell small-12 medium-6 medium-offset-3">
					<InputComponent
						:placeholderValue="$t('newaccount.addressPlaceholder') + '*'"
						v-model="address"
						:hasError="validation.address.error"
						:errorMessage="validation.address.message"
						:whiteErrorColor="true"
						:lightTheme="true"
						:autocomplete="'street-address'"
						@input-enter="retry()"
					></InputComponent>
				</div>

				<div
					class="cell small-12 medium-2 medium-offset-3 create-profile-form__margin"
				>
					<InputComponent
						:placeholderValue="$t('newaccount.zipcodePlaceholder') + '*'"
						v-model="zipcode"
						:hasError="validation.zipcode.error"
						:errorMessage="validation.zipcode.message"
						:whiteErrorColor="true"
						:lightTheme="true"
						:autocomplete="'postal-code'"
						@input-enter="retry()"
					></InputComponent>
				</div>

				<div class="cell small-12 medium-2 create-profile-form__margin">
					<InputComponent
						:placeholderValue="$t('newaccount.cityPlaceholder') + '*'"
						v-model="city"
						:hasError="validation.city.error"
						:errorMessage="validation.city.message"
						:whiteErrorColor="true"
						:lightTheme="true"
						:autocomplete="'address-level2'"
						@input-enter="retry()"
					></InputComponent>
				</div>

				<div class="cell small-12 medium-2">
					<Select
						v-model="country"
						:defaultSelectedValue="selectedCountry"
						placeholder="Välj Land*"
						:option-items="countryArray"
						:lightTheme="true"
					/>
				</div>

				<div
					class="cell small-12 medium-3 medium-offset-3 create-profile-form__margin"
				>
					<InputComponent
						:placeholderValue="$t('newaccount.emailPlaceholder') + '*'"
						v-model="email"
						:type="'email'"
						:hasError="validation.email.error"
						:errorMessage="validation.email.message"
						:whiteErrorColor="true"
						:lightTheme="true"
						:autocomplete="'email'"
						@input-enter="retry()"
					></InputComponent>
				</div>
				<div class="cell small-12 medium-3">
					<InputComponent
						:placeholderValue="$t('newaccount.emailConfirmPlaceholder') + '*'"
						v-model="emailconfirm"
						:type="'email'"
						:hasError="validation.emailconfirm.error"
						:errorMessage="validation.emailconfirm.message"
						:whiteErrorColor="true"
						:lightTheme="true"
						:autocomplete="'email'"
						@input-enter="retry()"
					></InputComponent>
				</div>
				<div class="grid-x cell small-12 medium-6 medium-offset-3">
					<div
						class="cell small-4 medium-3 large-2 create-profile-form__prefix"
					>
						<InputComponent
							placeholderValue="+46*"
							v-model="mobilephoneprefix"
							:type="'tel'"
							:hasError="validation.mobilephoneprefix.error"
							:errorMessage="validation.mobilephoneprefix.message"
							:whiteErrorColor="true"
							:lightTheme="true"
							@input-enter="retry()"
						></InputComponent>
					</div>
					<div class="cell small-8 medium-9 large-10">
						<InputComponent
							:placeholderValue="$t('newaccount.phoneNumberPlaceholder') + '*'"
							v-model="mobilephone"
							:type="'tel'"
							:hasError="validation.mobilephone.error"
							:errorMessage="validation.mobilephone.message"
							:whiteErrorColor="true"
							:lightTheme="true"
							:autocomplete="'tel'"
							@input-enter="retry()"
						></InputComponent>
					</div>
				</div>
				<div class="cell small-12 medium-6 medium-offset-3">
					<InputComponent
						type="password"
						:placeholderValue="$t('newaccount.passwordPlaceholder') + '*'"
						v-model="password"
						:hasError="validation.password.error"
						:errorMessage="validation.password.message"
						:whiteErrorColor="true"
						:lightTheme="true"
						:autocomplete="'new-password'"
						@input-enter="retry()"
					></InputComponent>
				</div>

				<!-- Marketing consent -->
				<div class="cell small-12 medium-6 medium-offset-3">
					<label class="checkbox checkbox--lightTheme">
						<input
							class="checkbox__input"
							type="checkbox"
							name="marketingConsent"
							value="marketingConsent"
							v-model="marketingConsent"
						/>
						<span class="checkbox__box">
							<span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
							</span>
						</span>
						<span
							class="create-profile-form__consent-text"
							v-html="$t('newaccount.marketingConsentText')"
						></span>
					</label>
				</div>

				<div
					v-if="apiResponseSuccess === false"
					class="cell small-6 small-offset-3 medium-6 medium-offset-3 large-6 large-offset-3 gutter-top"
				>
					<div class="api-response-error">
						<p>
							{{ $t('newaccount.emailAlreadyRegisteredText') }}
						</p>
					</div>
				</div>
				<div
					class="cell small-6 small-offset-3 medium-6 medium-offset-3 large-6 large-offset-3 gutter-top"
				>
					<Button
						submit
						full
						:loading="loading"
						class="create-profile-form__submit"
					>
						{{ $t('newaccount.registerButton') }}
					</Button>
				</div>
				<div class="cell">
					<router-link class="white underline back" :to="{ name: 'login' }">
						{{ $t('resetpassword.orLoginLink') }}
					</router-link>
				</div>

				<!-- Consent info -->
				<div
					class="cell small-12 medium-6 medium-offset-3 large-6 large-offset-3 gutter-top"
				>
					<p
						class="create-profile-form__consent-info"
						v-html="$t('newaccount.consentDescription')"
					></p>
				</div>
			</div>
		</form>
		<div v-if="showSuccess" class="grid-x grid-margin-y">
			<div class="cell small-10 small-offset-1 medium-6 medium-offset-3">
				<h1 class="h2 create-profile-form__title">
					{{ $t('newaccount.successTitle') }}
				</h1>
				<p class="create-profile-form__text">
					{{ $t('newaccount.successText') }}
				</p>
				<p>
					<router-link class="white underline back" :to="{ name: 'login' }">
						{{ $t('resetpassword.loginLink') }}
					</router-link>
				</p>
			</div>
		</div>
	</section>
</template>

<script>
import {
	testBasic,
	testEmail,
	testPassword,
	testPhoneNumber,
	testPrefix,
	validationErrors
} from '../../../utilities/validation'
import Button from '../../../components/atoms/Button'
import Select from '../../../components/atoms/Select'
import InputComponent from '../../../components/atoms/InputComponent'
import store from '../../../vueX/store'

export default {
	name: 'CreateProfile_Form',
	store,
	components: {
		InputComponent,
		Button,
		Select
	},
	data: () => {
		return {
			showSuccess: false,
			name: '',
			lastname: '',
			address: '',
			zipcode: '',
			city: '',
			password: '',
			email: '',
			emailconfirm: '',
			birth: '',
			mobilephoneprefix: '',
			mobilephone: '',
			country: '',
			selectedCountry: '',
			countryArray: [{}],
			loading: false,
			marketingConsent: false,
			validation: validationErrors,
			apiResponse: null
		}
	},
	methods: {
		createUser() {
			if (this.validate()) {
				this.loading = true
				store
					.dispatch('POST_USER', {
						name: this.name,
						lastname: this.lastname,
						address: this.address,
						zipcode: this.zipcode,
						city: this.city,
						country: this.country,
						password: this.password,
						email: this.email,
						mobilePhonePrefix: this.mobilephoneprefix,
						mobilePhone: this.mobilephone,
						marketingConsent: this.marketingConsent
					})
					.then(success => {
						if (success) {
							this.showSuccess = true
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
					})
			}
		},
		retry() {
			store.dispatch('CHANGE_API_RESP_STATUS', null)
			this.loading = false
		},
		validate() {
			let approved = true
			// reset errors and message before testing a new validation
			Object.keys(this.validation).map(key => {
				this.validation[key].error = false
				this.validation[key].message = ''
			})

			if (!testEmail(this.email)) {
				this.validation.email.error = true
				this.validation.email.message = this.$t('errorText.email')
				approved = false
			}

			if (this.email !== this.emailconfirm || this.emailconfirm === '') {
				this.validation.emailconfirm.error = true
				this.validation.emailconfirm.message = this.$t('errorText.emailConfirm')
				approved = false
			}

			if (!testPassword(this.password)) {
				this.validation.password.error = true
				this.validation.password.message = this.$t('errorText.password')
				approved = false
			}

			if (!testBasic(this.name)) {
				this.validation.name.error = true
				this.validation.name.message = this.$t('errorText.name')
				approved = false
			}

			if (!testBasic(this.lastname)) {
				this.validation.lastname.error = true
				this.validation.lastname.message = this.$t('errorText.lastname')
				approved = false
			}

			if (!testBasic(this.address)) {
				this.validation.address.error = true
				this.validation.address.message = this.$t('errorText.address')
				approved = false
			}

			if (!testBasic(this.zipcode)) {
				this.validation.zipcode.error = true
				this.validation.zipcode.message = this.$t('errorText.zipcode')
				approved = false
			}

			if (!testBasic(this.city)) {
				this.validation.city.error = true
				this.validation.city.message = this.$t('errorText.city')
				approved = false
			}

			if (!testPrefix(this.mobilephoneprefix)) {
				this.validation.mobilephoneprefix.error = true
				this.validation.mobilephoneprefix.message = this.$t('errorText.prefix')
				approved = false
			}

			if (!testPhoneNumber(this.mobilephone)) {
				this.validation.mobilephone.error = true
				this.validation.mobilephone.message = this.$t('errorText.phoneNumber')
				approved = false
			}

			return approved
		}
	},
	computed: {
		apiResponseSuccess() {
			if (this.$store.state.apiResponseStatus === 'User exists') {
				return false
			} else {
				return true
			}
		}
	},
	created() {
		// reset errors and message before testing a new validation
		Object.keys(this.validation).map(key => {
			this.validation[key].error = false
			this.validation[key].message = ''
		})
		store.dispatch('GET_COUNTRIES').then(data => {
			this.countryArray = data
			const newCountryArray = data.map(item => {
				return { id: item.isocode, text: item.name }
			})
			this.countryArray = newCountryArray
			this.country = 'SE'
			this.selectedCountry = 'SE'
		})
	}
}
</script>

<style scoped lang="scss">
.api-response-error {
	padding: 20px;
	background-color: $colorDarkerRed;

	p,
	a {
		font-size: 15px;
		color: $colorWhite;
	}

	a {
		text-decoration: underline;
	}
}

.create-profile-form {
	.input__container {
		margin-bottom: 10px;
	}
	text-align: center;
	margin-bottom: 40px;
	&__title,
	&__text {
		color: $colorWhite;
		text-align: center;
	}
	&__text {
		margin: 20px 0 40px;
	}

	.gutter-top {
		margin-top: 50px;
	}

	&__submit {
		margin-bottom: 20px;
	}

	&__prefix .input__container {
		margin-right: 20px;
	}

	&__margin .input__container {
		margin-right: 0;
		@include for-tablet-portrait-up {
			margin-right: 20px;
		}
	}

	&__consent-text {
		text-align: left;
		color: $colorWhite;
		margin-left: 10px;
		&:hover {
			cursor: pointer;
		}
	}

	&__consent-info {
		color: $colorWhite;
		font-size: 12px;
		line-height: 1.3;
		font-style: italic;
	}

	&__consent-error {
		text-align: left;
		p {
			font-size: 10px;
		}
		&--white {
			color: $colorWhite;
		}
	}
}

.checkbox {
	display: flex;
	position: relative;
	align-items: center;
	width: 100%;
	margin-top: 30px;
	.checkbox__box {
		flex: none;
	}
	&--disabled {
		opacity: 0.5;
		pointer-events: none;
	}
	&__input {
		position: absolute;
		visibility: hidden;
		/*&:checked ~ .input__icon:after {
      transform: scale(1);
    }*/

		+ span > span {
			display: none;
		}
		&:checked {
			+ span {
				background-color: $colorPrimary7;
			}
			+ span > span {
				display: block;
			}
		}
	}
	&__box {
		display: inline-block;
		width: 18px;
		height: 18px;
		box-sizing: border-box;
		border: 1px solid $colorPrimary3;
		box-shadow: inset 0 1px 3px 0 rgba(148, 158, 177, 0.1);
		background-color: rgba(233, 235, 239, 0.6);
		border-radius: 3px;
		transition: all 0.3s ease;
		margin-right: 5px;
		position: relative;
		svg {
			width: 12px;
			height: 12px;
		}
		> span {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	&__title {
		align-items: center;
		display: flex;
		color: $colorPrimary;
		font-size: 16px;
		line-height: 18px;
	}
	&--lightTheme {
		.checkbox__box {
			background-color: $colorWhite;
		}
	}
}
</style>
